<app-auth-shell [testimonial]="false">
  @if (vm$ | async; as vm) {
    @if (vm.currentConsent.data; as consent) {
      @if (consent.skip) {
        <!-- already granted: the challenge is confirmed without asking -->
        <div class="flex justify-center py-12" role="status">
          <vx-icon
            name="circle-notch"
            size="lg"
            class="animate-spin text-zinc-400 motion-reduce:animate-none" />
        </div>
      } @else {
        <app-auth-header
          [title]="'pages.auth.consent.title' | transloco"
          [subtitle]="'pages.auth.consent.subtitle' | transloco" />

        <app-auth-panel>
          <p class="text-sm tracking-tight text-zinc-300">
            {{
              'pages.auth.consent.requests'
                | transloco
                  : { client: consent.client.name || consent.client.id }
            }}
          </p>
          <ul class="flex flex-col gap-2">
            @for (scope of consent.requestedScopes; track scope) {
              <li
                class="flex items-center gap-2 font-mono text-13 tracking-tight text-zinc-200">
                <vx-icon name="check" size="sm" class="text-zinc-400" />
                {{ scope }}
              </li>
            }
          </ul>
          <vx-button
            size="lg"
            [fullWidth]="true"
            [loading]="vm.isLoading"
            (click)="onConsent()">
            {{ 'pages.auth.consent.allow' | transloco }}
          </vx-button>
        </app-auth-panel>
      }
    } @else {
      <vx-skeleton class="h-6 w-6 rounded-md" />
      <vx-skeleton class="mt-5 h-6.5 w-48" />
      <vx-skeleton class="mt-2 h-4 w-72" />
      <vx-skeleton class="mt-8 h-44 w-full rounded-2xl" />
    }
  }
</app-auth-shell>
